import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

const TOKEN_KEY = "bj_admin_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking | object | false
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));

  const verifyToken = useCallback(async (jwt) => {
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${jwt}` },
      });
      setUser(data);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (token) {
      verifyToken(token);
    } else {
      setUser(false);
    }
  }, [token, verifyToken]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export { API };
